import PropTypes from "prop-types";
import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  isConversationReadOnly,
  CONVERSATION_READ_ONLY_TYPES,
  getChannelPatientReadOnlyStatus,
} from "../../../../utils/chatUtils";

export const Channel = (props) => {
  const { channel, lastMessage, onSelectChannel, unreadMessageCount } = props;
  const { coverImage, otherMembers, url } = channel;
  const history = useHistory();
  const profile = useSelector((state) => state.auth.profile);

  let nameOnClick, nameClass;

  if (profile?.provider_type) {
    const memberId = otherMembers?.length && otherMembers[0].userId;
    const memberProfileLink = `/app/patient/${memberId}/profile/v2`;

    nameOnClick = () => history.push(memberProfileLink);
    nameClass = "chat-member-name";
  }

  const formattedLastMessage = lastMessage || {
    message: "No messages sent yet!",
    formattedTime: "",
  };

  const isReadOnly = isConversationReadOnly(profile?.care_team_members, channel);
  const isProviderNoLongerOnCareTeamReadOnly =
    isReadOnly === CONVERSATION_READ_ONLY_TYPES.PROVIDER_NO_LONGER_ON_CARE_TEAM;

  const channelOpacity = isProviderNoLongerOnCareTeamReadOnly ? 0.6 : 1.0;

  const userAvatar = (
    <div>
      <img src={coverImage} alt="avatar" className="avatar" />
      {unreadMessageCount > 0 && <div className="number-circle">{unreadMessageCount}</div>}
    </div>
  );

  const channelText = (
    <div className="card-text">
      <span className={nameClass} onClick={nameOnClick}>
        <strong>
          {otherMembers
            .map(
              (user) =>
                `${user.nickname}${
                  user?.metaData?.preferred_name ? ` (${user.metaData.preferred_name})` : ""
                }`,
            )
            .join()}
        </strong>
      </span>
      <p className={`fs-12 ${formattedLastMessage.message.trim() === "" ? "mb-4 pb-2" : ""}`}>
        {formattedLastMessage.message}
      </p>
    </div>
  );

  const lastMessageTimeText = <div>{formattedLastMessage.formattedTime}</div>;

  const isReadOnlyBadge = (
    <div className="read-only-channel-badge">
      <span>Read Only</span>
    </div>
  );

  return (
    <li key={url} style={{ opacity: channelOpacity }}>
      <div
        className="card card-body card-grid"
        onClick={() => {
          onSelectChannel(channel);
        }}
        data-e2e="Messages__channel"
      >
        {userAvatar}
        {channelText}
        <div className="fs-11 card-time mt-1 text-right">
          {lastMessageTimeText}
          {getChannelPatientReadOnlyStatus(channel) && isReadOnlyBadge}
        </div>
      </div>
    </li>
  );
};

Channel.propTypes = {
  channel: PropTypes.object.isRequired,
  lastMessage: PropTypes.object.isRequired,
  onSelectChannel: PropTypes.func.isRequired,
  unreadMessageCount: PropTypes.number.isRequired,
};
